import styled from "@emotion/styled";
import { colors, customEvent } from "goi_common";

export const REGION_MAP: Record<string, string> = {
  서울특별시: "서울",
  경기도: "경기",
  인천광역시: "인천",
  부산광역시: "부산",
  대구광역시: "대구",
  광주광역시: "광주",
  대전광역시: "대전",
  울산광역시: "울산",
  세종특별자치시: "세종",
  강원특별자치도: "강원",
  강원도: "강원",
  충청북도: "충북",
  충청남도: "충남",
  전북특별자치도: "전북",
  전라남도: "전남",
  경상북도: "경북",
  경상남도: "경남",
  제주특별자치도: "제주",
};

export const REGIONS = [
  "서울",
  "경기",
  "인천",
  "부산",
  "대구",
  "광주",
  "대전",
  "울산",
  "강원",
  "충북",
  "충남",
  "전북",
  "전남",
  "경북",
  "경남",
  "제주",
  "세종",
];

export const getRegionShort = (address: string): string => {
  const first = address?.split(" ")[0] ?? "";
  return REGION_MAP[first] ?? "기타";
};

interface HomeRegionFilterProps {
  activeRegion: string | null;
  onRegionChange: (region: string | null) => void;
}

export const HomeRegionFilter = ({
  activeRegion,
  onRegionChange,
}: HomeRegionFilterProps) => {
  return (
    <FilterRoot>
      <FilterLabel>지역별 보기</FilterLabel>
      <ChipWrap>
        <Chip
          isActive={activeRegion === null}
          onClick={() => {
            customEvent({
              newGtm: {
                path: "prlr_home",
                trigger_and_target: "region_filter-tab",
              },
            });
            onRegionChange(null);
          }}
        >
          전체
        </Chip>
        {REGIONS.map((region) => (
          <Chip
            key={region}
            isActive={activeRegion === region}
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "prlr_home",
                  trigger_and_target: "region_filter-tab",
                },
              });
              onRegionChange(activeRegion === region ? null : region);
            }}
          >
            {region}
          </Chip>
        ))}
      </ChipWrap>
    </FilterRoot>
  );
};

const FilterRoot = styled.div`
  width: 100%;
  padding: 14px 16px 4px;
`;

const FilterLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${colors.gray500};
  margin-bottom: 10px;
  letter-spacing: 0.03em;
`;

const ChipWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Chip = styled.button<{ isActive: boolean }>`
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: ${({ isActive }) => (isActive ? 600 : 400)};
  cursor: pointer;
  transition: all 0.15s;
  background: ${({ isActive }) => (isActive ? colors.gray900 : colors.white)};
  color: ${({ isActive }) => (isActive ? colors.white : colors.gray600)};
  border: 1px solid
    ${({ isActive }) => (isActive ? colors.gray900 : colors.gray200)};
`;
